{
  "car": "kite-r2",
  "radii": [
    10,
    15,
    22,
    32,
    45,
    65,
    90,
    130,
    190,
    280
  ],
  "gravel": [
    8.75,
    10.67,
    12.76,
    14.99,
    17.54,
    20.81,
    24.5,
    30.06,
    36.88,
    45.38
  ],
  "tarmac": [
    9.64,
    11.96,
    14.53,
    17.27,
    20.22,
    24.1,
    28.18,
    34.48,
    42.21,
    51.28
  ],
  "method": "max speed held ≥1.5 s within 2.5 m of a flat constant-radius circle, pure-pursuit driver, speed ramp"
}
